import styled, { css } from 'styled-components';

import Button from '@components/Button/next';

export const ResponsiveBox = styled.div`
  width: 100%;
  height: auto;
  padding: 6px 8px 6px 8px !important;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 8px;
`;

export const ResponsiveSearchBoxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
`;

export const SearchBoxDateWrapper = styled.div``;

export const AirportWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SwitchAirportIconWrapper = styled.div`
  margin: 0px 10px;
`;

export const ResponsiveSearchBoxItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
`;

export const ResponsiveSearchBoxLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
  color: ${({ theme }) => theme.palette.NL800};
`;

export const ResponsiveSearchBoxLabelBig = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.coral};
`;

export const ResponsiveSearchBoxEdit = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  line-height: normal;
`;
export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.NL20};
  padding: 8px;
  border-radius: 8px;
`;
export const WrapperFlight = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const ResponsiveSearchBoxEditLabel = styled.span`
  font-size: 12px;
  text-decoration: underline;
  color: ${({ theme }) => theme.palette.B300};
`;

export const SearchBoxSpacer = styled.div`
  margin-bottom: 2px;
`;

export const LocationAnimationErrorBox = styled.div<{
  hasError: boolean;
  hasAnimationOnError?: boolean;
  borderRadius?: string;
}>`
  flex: 1;
  height: fit-content;
  overflow: hidden;
  background-color: ${({ theme }) => theme.palette.NL0};
  border-radius: ${({ borderRadius }) => borderRadius || '0'};
  ${({ hasError, hasAnimationOnError = true, borderRadius = '0' }) =>
    hasError &&
    css`
      border-radius: ${borderRadius};
      border: ${({ theme }) => `1px solid ${theme.palette.coral}`};
      animation: ${() =>
        hasAnimationOnError &&
        'shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97)'};
    `}

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;

export const SearchButton = styled(Button)<{
  isPackageListing?: boolean;
}>`
  height: auto;
  font-size: 18px;
  font-weight: bold;
  border-radius: 8px;
`;
